import { SET_MODE } from './actionsTypes'

const defaultMode = window.matchMedia('(prefers-color-scheme: dark)').matches
  ? 'dark'
  : 'light'

const initialState = {
  selectedMode: !!localStorage.getItem('mode')
    ? localStorage.getItem('mode')
    : defaultMode,
}

const Mode = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_MODE:
      return {
        ...state,
        selectedMode: payload,
      }
    default:
      return state
  }
}

export default Mode
